// src/app/auth.custom.interceptor.ts

import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AdminConnectionContextService } from 'app/core/services';
import { SKIP_ADMIN_CONNECTION_CONTEXT } from './admin-connection-context.token';

export const customAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const adminConnectionContext = inject(AdminConnectionContextService);

  // Define the condition for when to add the token:
  // 1. Must be a call to our own API.
  // 2. Must NOT be the file download path.
  const isAnonymousPatientSmileUpload = /\/patient-smile-upload\/(?:links|uploads)(?:\/|$|\?)/.test(req.url);
  const isOwnApiRequest: boolean = req.url.startsWith(environment.apiBaseUrl);
  const shouldAttachToken = isOwnApiRequest && !req.url.includes('/patients/') && !isAnonymousPatientSmileUpload;
  const connectedUserId: string | null = adminConnectionContext.getConnectedUserId();
  const request =
    shouldAttachToken && !req.context.get(SKIP_ADMIN_CONNECTION_CONTEXT) && connectedUserId !== null
      ? req.clone({ setHeaders: { 'X-Admin-Connected-User-Id': connectedUserId } })
      : req;

  if (shouldAttachToken) {
    return authService.getAccessTokenSilently().pipe(
      switchMap(token => {
        const authReq = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
        return next(authReq);
      })
    );
  } else {
    // For S3 downloads or other requests, pass them through without a token.
    return next(request);
  }
};
